export default __webpack_public_path__ + "locales/ko-KR/InfoPanel.json?hash=e1418e7fe28c78c11d1c1856182944f3";